import { cloneDeep } from 'lodash';

import type { Channel, Item } from '../../../models';
import { enhanceFetchedAsset } from '../../../pages/assets/asset-listing/enhanceFetchedAsset';
import type { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';
import { AssetLookup } from '../../../utils/assetLookup';

export class LiveTransitionsForm {
  BeginMomentarily: string[] = [];
  beginMomentarilySelection: Item | null = null;

  StartupLive: string[] = [];
  startupLiveSelection: Item | null = null;

  PreRecordedToLive: string[] = [];
  preLiveSelection: Item | null = null;

  PostLiveItem: string[] = [];
  postLiveSelection: Item | null = null;

  ContentRestricted: string[] = [];
  contentRestrictedSelection: Item | null = null;

  // ad fillers are mapped to channel.contentPools[0].items - its always the first element in contentPools...
  liveAdBreakFillers: Item[] = [];

  static createFromData(data: ChannelFormData, permissions, flags, ouData): LiveTransitionsForm {
    const form = new LiveTransitionsForm();
    form.loadData(data, permissions, flags, ouData);
    return form;
  }

  loadData(data: ChannelFormData, permissions, flags, ouData) {
    const { channel, assets } = data;
    const assetLookup = new AssetLookup(assets);

    this.loadLiveTransitionsFromMetadata(channel, assetLookup);
    this.loadLiveAdBreakFillersFromMetadata(channel, assetLookup, permissions, flags, ouData);
  }

  private loadLiveTransitionsFromMetadata(channel: Channel, assetLookup: AssetLookup) {
    const liveFillers = channel.metaData.fillers;
    // console.log('liveFillers', liveFillers);
    if (liveFillers) {
      if (liveFillers && liveFillers.BeginMomentarily && liveFillers.BeginMomentarily.length) {
        this.BeginMomentarily = liveFillers.BeginMomentarily;
        this.beginMomentarilySelection = assetLookup.smartGetById(this.BeginMomentarily[0]);
      }
      if (liveFillers && liveFillers.StartupLive && liveFillers.StartupLive.length) {
        this.StartupLive = liveFillers.StartupLive;
        this.startupLiveSelection = assetLookup.smartGetById(this.StartupLive[0]);
      }

      if (liveFillers && liveFillers.PreRecordedToLive && liveFillers.PreRecordedToLive.length) {
        this.PreRecordedToLive = liveFillers.PreRecordedToLive;
        this.preLiveSelection = assetLookup.smartGetById(this.PreRecordedToLive[0]);
      }
      if (liveFillers && liveFillers.SwitchToMostRecent && liveFillers.SwitchToMostRecent.length) {
        this.PostLiveItem = liveFillers.SwitchToMostRecent;
        this.postLiveSelection = assetLookup.smartGetById(this.PostLiveItem[0]);
      }
      if (liveFillers && liveFillers.ContentRestricted && liveFillers.ContentRestricted.length) {
        this.ContentRestricted = liveFillers.ContentRestricted;
        this.contentRestrictedSelection = assetLookup.smartGetById(this.ContentRestricted[0]);
      }
    }
  }

  private loadLiveAdBreakFillersFromMetadata(channel: Channel, assetLookup: AssetLookup, permissions, flags, ouData: OU) {
    const adFillers = channel.metaData.fillers.AdFiller;
    if (adFillers && adFillers.length) {
      const itemIds = adFillers;
      this.liveAdBreakFillers = itemIds.map((itemId) => {
        const item = assetLookup.smartGetById(itemId);
        const newItem = enhanceFetchedAsset(
          cloneDeep(item),
          permissions,
          flags,
          true,
          channel.metaData?.variantCodes,
          [],
          ouData
        );
        return newItem;
      });
    }
  }
}
